export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/home.91d31d39.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};